<template>
  <nav class="blog--breadcrumb">
    <ul>
      <li v-for="(item, i) in items" :key="i">
        <span class="dot" v-if="i !== 0 && i !== item.length-1">></span>
        <a :href="item.href">{{item.name}}</a>
      </li>
    </ul>
  </nav>
</template>
<script>
export default {
  name: 'Breadcrumb',
  props: {
    items: {
      type: Array,
      required: true,
      description: 'Breadcrumb items',
    },
  },
};
</script>

<style scoped>
  .blog--breadcrumb ul {
    display: flex;
    list-style: none;
    padding: 0;
    font-size: .9rem;
    margin-bottom: .2rem;
  }
  .blog--breadcrumb a {
    text-decoration: none;
    color: var(--blog-link);
  }
  .dot{
    margin: .4rem;
  }
</style>
